module.exports = __webpack_public_path__ + "media/0001.e9b71333.mp3";